import { axiosApi } from '@/api/axios';

export default {
  index() {
    return axiosApi.get('/filters');
  },
};
